import mainPageModel                      from '../main-navigation/MainPageModel';
import RuleSettingsEditorModel            from './RuleSettingsEditorModel';

export const autoSchedulerRuleSetId = 'Ea11VJm6gUipdlA5xlZYqA';

export default class AutoSchedulerRuleEditorModel extends RuleSettingsEditorModel {
  constructor() {
    super('Auto Schedule', autoSchedulerRuleSetId);
  }

  get access(): boolean {
    return mainPageModel.timecardRulesAccess;
  }

  get _canAddItem(): boolean {
    return mainPageModel.canEditTimecardRules;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditTimecardRules;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canEditTimecardRules;
  }
}
